import React, { useCallback, useEffect } from 'react';
import useSetState from 'customHooks/setState';
import Button from 'components/Button';
import Input from 'components/common/Input';
import styles from './index.module.scss';

export const AudioComponent = ({
    value = [],
    onChange = () => { }
}) => {

    const [{ dataList }, setState] = useSetState({
        dataList: value
    });

    const addNewSrcFiled = useCallback(() => {
        const temp = dataList.concat();
        temp.push('');
        setState({ dataList: temp });
    }, [dataList, setState]);


    const inputChangeHandler = useCallback(index => e => {
        let tempDataList = dataList.concat();
        tempDataList[index] = e.target.value.trim();
        tempDataList = tempDataList.filter(item => item)
        setState({ dataList: tempDataList });
        onChange(tempDataList);
    }, [dataList, onChange, setState]);

    const transDataType = data => {
        return typeof data === 'string' ? [data] : data;
    };

    return (
        <div className={styles.audioComponent}>
            <Button className={styles.addSrcButton} onClick={addNewSrcFiled}>新增來源</Button>
            {
                transDataType(dataList).map((item, index) => (
                    <Input
                        className={styles.input}
                        label={`分段音檔 ${index + 1}`}
                        value={item}
                        onChange={inputChangeHandler(index)}
                    />
                ))
            }
        </div>
    )

};
